/* projects/portal/src/app/pages/shell/shell.component.css */
.shell {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--canvas);
}
.shell-top {
  display: flex;
  align-items: center;
  gap: 12px;
  height: 60px;
  padding: 0 16px;
  background-color: var(--header-color);
  color: var(--light-text);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  position: sticky;
  top: 0;
  z-index: 20;
}
.shell-burger {
  display: none;
  color: var(--light-text);
}
.shell-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}
.shell-logo {
  height: 26px;
  width: auto;
}
.shell-title {
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.2px;
}
.shell-spacer {
  flex: 1 1 auto;
}
.shell-company {
  font-size: 14px;
  opacity: 0.85;
}
.shell-lang {
  display: flex;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 4px;
  overflow: hidden;
}
.shell-lang-btn {
  border: none;
  background: transparent;
  color: var(--light-text);
  opacity: 0.6;
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.3px;
  padding: 6px 10px;
  cursor: pointer;
}
.shell-lang-btn:hover {
  opacity: 0.85;
}
.shell-lang-active {
  opacity: 1;
  background: rgba(255, 255, 255, 0.15);
}
.shell-customer {
  width: 220px;
  margin-bottom: -1.25em;
}
.shell-customer ::ng-deep .mat-mdc-form-field-infix {
  padding-top: 8px;
  padding-bottom: 8px;
  min-height: 0;
}
.shell-customer ::ng-deep .mdc-notched-outline__leading,
.shell-customer ::ng-deep .mdc-notched-outline__notch,
.shell-customer ::ng-deep .mdc-notched-outline__trailing {
  border-color: rgba(255, 255, 255, 0.35) !important;
}
.shell-customer ::ng-deep .mat-mdc-select-value,
.shell-customer ::ng-deep .mat-mdc-select-arrow,
.shell-customer ::ng-deep .mat-mdc-floating-label {
  color: var(--light-text) !important;
}
.shell-user {
  color: var(--light-text);
}
.shell-user-name {
  margin: 0 6px;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.shell-menu-head {
  padding: 12px 16px;
  border-bottom: 1px solid var(--line);
}
.shell-menu-name {
  font-weight: 500;
  font-size: 14px;
  color: var(--ink);
}
.shell-menu-email {
  font-size: 12px;
  color: var(--ink-muted);
}
.shell-menu-role {
  font-size: 11px;
  color: #8a5a12;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-top: 4px;
}
.shell-body {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}
.shell-nav {
  width: 216px;
  flex: none;
  padding: 16px 10px;
  background: var(--surface);
  border-right: 1px solid var(--line);
}
.shell-nav a {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  margin-bottom: 4px;
  border-radius: 4px;
  color: var(--subheader-color);
  text-decoration: none;
  font-size: 14px;
  font-weight: 400;
}
.shell-nav a:hover {
  background: #f2f1ef;
}
.shell-nav a.active {
  background: #fdf0dc;
  color: var(--ink);
  font-weight: 500;
  box-shadow: inset 3px 0 0 var(--primary-color);
}
.shell-nav mat-icon {
  font-size: 20px;
  height: 20px;
  width: 20px;
}
.shell-main {
  flex: 1 1 auto;
  min-width: 0;
  padding: 24px;
}
@media (max-width: 820px) {
  .shell-burger {
    display: inline-flex;
  }
  .shell-title {
    display: none;
  }
  .shell-nav {
    position: fixed;
    top: 60px;
    bottom: 0;
    left: 0;
    z-index: 15;
    transform: translateX(-100%);
    transition: transform 0.18s ease;
    box-shadow: 4px 0 16px rgba(0, 0, 0, 0.12);
  }
  .shell-nav-open {
    transform: translateX(0);
  }
  .shell-main {
    padding: 16px;
  }
  .shell-customer {
    width: 150px;
  }
  .shell-user-name {
    display: none;
  }
}
/*# sourceMappingURL=shell.component.css.map */
